/**
 * Created by jacmai on 6/30/2017.
 */
define(["jquery", "marionette", "./template/responsePreviewTemplate.html"], function (
  $,
  Marionette,
  ResponsePreviewTemplate,
) {
  "use strict";

  const ResponsePreviewView = {};

  ResponsePreviewView.responsePreviewView = Marionette.ItemView.extend({
    template: ResponsePreviewTemplate,
    initialize: function () {
      this.listenTo(this.model.get("touchPoints"), "sync", this.render);
      this.listenTo(this.model.get("locales"), "sync", this.render);
    },
    events: {
      "change #touchpoints": function () {
        const optionSelected = this.$el.find("#touchpoints option:selected").val();
        this.model.set("selectedTouchPoint", parseInt(optionSelected, 10));
        this.trigger(
          "change:response",
          this.model.get("selectedTouchPoint"),
          this.model.get("selectedLocale"),
        );
      },
      "change #languages": function () {
        const optionSelected = this.$el.find("#languages option:selected").val();
        this.model.set("selectedLocale", parseInt(optionSelected, 10));
        this.trigger(
          "change:response",
          this.model.get("selectedTouchPoint"),
          this.model.get("selectedLocale"),
        );
      },
    },
    modelEvents: {
      "change:response": "render",
    },
    triggers: {
      "click #edit": "edit:response",
    },
    onDomRefresh: function () {
      // Enable extra jQuery UI widgets in response
      $(".accordion").accordion({
        collapsible: true,
        heightStyle: "content",
      });
    },
  });

  return ResponsePreviewView;
});
